var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1121 9.05614C16.1121 10.7352 15.5257 12.2773 14.5464 13.4888C14.5758 13.5107 14.604 13.535 14.6307 13.5617L16.3977 15.3287C16.7937 14.9876 17.3919 15.0048 17.7675 15.3804L21.7048 19.3177C22.0803 19.6932 22.0976 20.2915 21.7565 20.6875L21.7584 20.6894L21.7144 20.7335C21.7112 20.7367 21.708 20.74 21.7048 20.7432L20.7432 21.7048C20.74 21.708 20.7367 21.7112 20.7335 21.7144L20.6893 21.7586L20.6873 21.7567C20.2913 22.0976 19.6932 22.0803 19.3177 21.7048L15.3805 17.7675C15.0049 17.392 14.9876 16.7939 15.3286 16.3978L13.5615 14.6308C13.5348 14.6041 13.5106 14.5759 13.4887 14.5465C12.2773 15.5258 10.7352 16.1123 9.05607 16.1123C5.15911 16.1123 2 12.9531 2 9.05614C2 5.15914 5.15911 2 9.05607 2C12.953 2 16.1121 5.15914 16.1121 9.05614Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e73b034fe7b1cd7776fe9c78afa062b6.svg";
export { ForwardRef as ReactComponent };